// ink-component
import React, { ReactNode, OlHTMLAttributes } from 'react';
import styled, { css } from 'styled-components';

import getGlobalProps from '../../helpers/constants/global-props';

export interface OlProps extends OlHTMLAttributes<HTMLOListElement> {
  /** Content */
  children: ReactNode;
}

const olTypeList = { 1: 'decimal', A: 'upper-alpha', a: 'lower-alpha', I: 'upper-roman', i: 'lower-roman' };

const StyledOList = styled.ol`
  list-style: decimal outside;
  padding-left: 20px;

  ${({ theme }) =>
    theme.type &&
    css`
      list-style-type: ${olTypeList[theme.type]};
    `}
`;

const globalProps = getGlobalProps({});

/**
 * @purpose Present ordered text elements as a numbered list
 * @group SimpleList
 * @categories layout
 * @aka ordered list
 */
export function Ol(props: OlProps) {
  const { style, className, ...otherProps } = props;

  /* Safari/webkit requires explicit role tag */
  /* https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility_concerns */

  return <StyledOList theme={{ type: otherProps.type }} {...otherProps} {...globalProps} role="list" />;
}

Ol.displayName = 'Ol';

export default Ol;
